import { S, Icon } from '../regureStyles';

export const STATUS_MAP = {
  submitted: { label: 'Submitted', color: '#10b981', bg: '#ecfdf5' },
  review: { label: 'Under Review', color: '#f59e0b', bg: '#fffbeb' },
  draft: { label: 'Draft', color: '#64748b', bg: '#f1f5f9' },
  overdue: { label: 'Overdue', color: '#ef4444', bg: '#fef2f2' },
};

const Filters = ({ search, setSearch, filterCategory, setFilterCategory, categories, filterStatus, setFilterStatus, statuses }) => {
  return (
    <div
      style={{
        background: '#fff',
        border: `1px solid ${S.borderLight}`,
        borderRadius: 10,
        padding: '16px 20px',
        marginBottom: 20,
        display: 'flex',
        gap: 12,
        alignItems: 'center',
      }}
    >
      <div style={{ position: 'relative', flex: 1, maxWidth: 320 }}>
        <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: S.textMuted }}>
          <Icon name='search' size={15} />
        </span>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder='Search reports...'
          style={{
            width: '100%',
            padding: '8px 12px 8px 34px',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 7,
            fontSize: 13,
            outline: 'none',
            color: S.textPrimary,
          }}
        />
      </div>
      <select
        value={filterCategory}
        onChange={e => setFilterCategory(e.target.value)}
        style={{ padding: '8px 12px', border: `1px solid ${S.borderLight}`, borderRadius: 7, fontSize: 13, color: S.textPrimary, outline: 'none', cursor: 'pointer' }}
      >
        {categories.map(c => (
          <option key={c}>{c}</option>
        ))}
      </select>
      <select
        value={filterStatus}
        onChange={e => setFilterStatus(e.target.value)}
        style={{ padding: '8px 12px', border: `1px solid ${S.borderLight}`, borderRadius: 7, fontSize: 13, color: S.textPrimary, outline: 'none', cursor: 'pointer' }}
      >
        {statuses.map(s => (
          <option key={s} value={s}>
            {s === 'All' ? 'All Statuses' : STATUS_MAP[s]?.label || s}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Filters;
